import styled from "styled-components";
import { CustomButton } from "../../../Components/CustomButton/Button";

export const ContainerAvatarUser = styled.div`
  max-width: 100%;
  padding: 16px;
  position: relative;

  @media (min-width: 744px) {
    max-width: 348px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 1024px) {
    max-width: 310px;
  }

  @media (min-width: 1440px) {
    max-width: 448px;
  }
`;

export const AvatarModel = styled.img`
  width: 358px;
  height: 358px;
  object-fit: fill;
  border-radius: 50%;

  @media (min-width: 428px) {
    width: 396px;
    height: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
    height: 348px;
  }

  @media (min-width: 1024px) {
    width: 310px;
    height: 310px;
  }

  @media (min-width: 1440px) {
    width: 448px;
    height: 448px;
  }
`;

export const ButtonClose = styled(CustomButton)`
  width: 50px;
  height: 50px;
  position: absolute;
  right: 45px;
  top: 20px;

  background: #f64747;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 1024px) {
    width: 60px;
    height: 60px;
    right: 23px;
    top: 20px;
  }

  @media (min-width: 1440px) {
    width: 80px;
    height: 80px;
  }
`;
